var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("p", [
      _vm._v("Сумма в заявке "),
      _c("strong", [_vm._v(_vm._s(_vm.order.price))]),
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v("Реквизиты привязаны к заявке на сумму "),
      _c("strong", [_vm._v(_vm._s(_vm.order.no_cash_price))]),
    ]),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert alert-info" }, [
      _c("p", [_vm._v("Рекомендации")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            "установить скидку (в допустимых пределах) в заявке, чтобы суммы в реквизитах и сумма заявки были равны"
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "установить доставку (в допустимых пределах) в заявке, чтобы суммы в реквизитах и сумма заявки были равны"
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("привязать новые реквизиты с действующей суммой заявки"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }